import { IPickup } from '@/models/regions.model';
import { TFunction } from 'i18next';

export const getRegionActiveOptions = (t: TFunction) => [
  { value: true, label: t('regions_list_active') },
  { value: false, label: t('regions_list_inactive') },
];

export const getSettlementHeaderOptions = (t: TFunction) => [
  { value: true, label: t('region_settlements_yes') },
  { value: false, label: t('region_settlements_no') },
];

export const getCurrentLocationOptions = (pickup?: IPickup | null) => {
  if (!pickup) {
    return {
      region: [],
      settlement: [],
    };
  }
  return {
    region: [{ value: pickup?.settlement?.region?.id, label: pickup?.settlement?.region?.name }],
    settlement: [{ value: pickup?.settlement?.id, label: pickup?.settlement?.name }],
  };
};
